// extracted by mini-css-extract-plugin
export default {"card":"GroupsGrid_card__TBiBH","grid-container":"GroupsGrid_grid-container__HfS0C","grid-ul":"GroupsGrid_grid-ul__QhK00","grid-li":"GroupsGrid_grid-li__PhOjt"};